import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpModule } from '@angular/http'

import {
  AlertService,
  AuthenticationService,
  UserService
} from '../theme/shared'
import { AlertComponent } from './_directives/alert.component'
import { AdminAuthGuard, AuthGuard, DeviceManagerAuthGuard } from './_guards'
import { AuthRoutingModule } from './auth-routing.routing'
import { AuthComponent } from './auth.component'
import { LogoutComponent } from './logout/logout.component'

@NgModule({
  declarations: [AuthComponent, AlertComponent, LogoutComponent],
  entryComponents: [AlertComponent],
  imports: [CommonModule, FormsModule, HttpModule, AuthRoutingModule],
  providers: [
    AuthGuard,
    AdminAuthGuard,
    DeviceManagerAuthGuard,
    AlertService,
    AuthenticationService,
    UserService
  ]
})
export class AuthModule {}
